import { render, staticRenderFns } from "./AegUpdateTransaction.vue?vue&type=template&id=3d6ce6b6"
import script from "./AegUpdateTransaction.vue?vue&type=script&lang=js"
export * from "./AegUpdateTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports